var map = {
	"./emoji1.png": 3165,
	"./emoji10.png": 9753,
	"./emoji11.png": 3504,
	"./emoji12.png": 7323,
	"./emoji13.png": 6818,
	"./emoji14.png": 8541,
	"./emoji15.png": 7412,
	"./emoji16.png": 2527,
	"./emoji17.png": 7334,
	"./emoji18.png": 8849,
	"./emoji19.png": 7720,
	"./emoji2.png": 1398,
	"./emoji20.png": 804,
	"./emoji21.png": 4701,
	"./emoji22.png": 4374,
	"./emoji23.png": 7663,
	"./emoji24.png": 6336,
	"./emoji3.png": 5199,
	"./emoji4.png": 7168,
	"./emoji5.png": 1369,
	"./emoji6.png": 3186,
	"./emoji7.png": 8379,
	"./emoji8.png": 716,
	"./emoji9.png": 2341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4401;